export const OTP_VERIFY_REQUEST = 'OTP_VERIFY_REQUEST';
export const OTP_VERIFY_SUCCESS = 'OTP_VERIFY_SUCCESS';
export const OTP_VERIFY_FAILURE = 'OTP_VERIFY_FAILURE';
export const SET_RESET_TOKEN = 'SET_RESET_TOKEN';
export const OTP_RESEND_REQUEST = 'OTP_RESEND_REQUEST';
export const OTP_RESEND_FAILURE = 'OTP_RESEND_FAILURE';

export const otpVerifyRequest = (values) => ({
  type: OTP_VERIFY_REQUEST,
  payload: values,
});

export const otpVerifySuccess = () => ({
  type: OTP_VERIFY_SUCCESS,
});

export const otpVerifyFailure = (error) => ({
  type: OTP_VERIFY_FAILURE,
  payload: error,
});

export const otpResendFailure = (error) => ({
  type: OTP_RESEND_FAILURE,
  payload: error,
});

export const setResetToken = (token) => ({
  type: SET_RESET_TOKEN,
  payload: token,
});

export const otpResend = (values) => ({
  type: OTP_RESEND_REQUEST,
  payload: values,
});
